import store from '@/state/store'
import router from '@/router/index'

export default async function logout() {
  store.commit('unsetUser')
  store.commit('unsetCart')

  router.push({ name: 'index', query: { sessionExpired: true } })
}
